<template>
  <v-container
    :class="containerClasses"
  >
    <avs-backButton
      v-if="!inDialog"
      backTo="CompanyVehicles"
    />

    <AvsSteppers
      :value="tab"
      @change="v => (tab = v)"
    >
      <!-- ===== EN-TÊTES ===== -->
      <template v-slot:headers>
        <AvsStep
          step="1"
          :rules="[() => isFormValid.informations]"
        >
          {{ $t("commons.informations") }}
          <small v-show="!isFormValid.informations">{{ $t("commons.validation_issues") }}</small>
        </AvsStep>
      </template>

      <!-- ===== CONTENU ===== -->
      <template v-slot:items>
        <v-stepper-content step="1" style="margin-top: -10px;">
          <v-form
            ref="form-informations"
            v-model="isFormValid.informations"
            lazy-validation
          >
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="staff.registration_number"
                  :rules="isDisable ? [] : rules.registration_number"
                  :disabled="isDisable"
                  clearable
                  dense
                  outlined
                  :label="$t('N° Matricule du vehicule')"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="staff.vin"
                  :rules="isDisable ? [] : rules.vin"
                  :disabled="isDisable"
                  clearable
                  dense
                  outlined
                  :label="$t('N° Chassis')"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="staff.color"
                  :rules="isDisable ? [] : rules.color"
                  :disabled="isDisable"
                  clearable
                  dense
                  outlined
                  :label="$t('Couleur')"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="selectedBrand"
                  :items="brands"
                  :label="$t('Marque')"
                  outlined
                  dense
                  clearable
                  @change="updateModels"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="selectedModel"
                  :items="models"
                  :label="$t('Modèle')"
                  outlined
                  dense
                  clearable
                  :disabled="!selectedBrand"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="staff.year"
                  :rules="isDisable ? [] : rules.year"
                  :disabled="isDisable"
                  type="number"
                  clearable
                  dense
                  outlined
                  :label="$t('Année')"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="6" v-if="selectedBrand === 'Autre'">
                <v-text-field
                  v-model="staff.other_make"
                  :rules="rules.other_make"
                  :disabled="isDisable"
                  clearable
                  dense
                  outlined
                  :label="$t('Autre Marque')"
                />
              </v-col>
              <v-col cols="12" md="6" v-if="selectedModel === 'Autre' || selectedBrand === 'Autre'">
                <v-text-field
                  v-model="staff.other_model"
                  :rules="rules.other_model"
                  :disabled="isDisable"
                  clearable
                  dense
                  outlined
                  :label="$t('Autre Model')"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="staff.vehicle_type"
                  :items="vehicleItems"
                  :rules="rules.vehicle_type"
                  :disabled="isDisable"
                  dense
                  clearable
                  outlined
                  :label="$t('Type de vehicule')"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="staff.product"
                  :disabled="isDisable"
                  :items="products"
                  :rules="rules.products"
                  item-text="name"
                  item-value="id"
                  :label="$t('Type de Carburant')"
                  dense
                  clearable
                  outlined 
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="staff.reservoir_capacity"
                  :rules="isDisable ? [] : rules.reservoir_capacity"
                  :disabled="isDisable"
                  type="number"
                  clearable
                  dense
                  outlined
                  :label="$t('Capacité reservoir')"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="staff.department"
                  :disabled="isDisable"
                  :items="departments"
                  :rules="rules.departments"
                  item-text="name"
                  item-value="id"
                  :label="$t('Departement')"
                  attach
                  clearable
                  dense
                  outlined
                />
              </v-col>

              <v-col cols="12" md="8">
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-file-input
                      v-model="carteGriseFile"
                      :rules="carteGriseRules"
                      :disabled="isDisable"
                      clearable
                      dense
                      outlined
                      show-size
                      accept=".pdf,.jpg,.jpeg,.png"
                      :label="$t('Carte Grise')"
                      @change="handleCarteGriseUpload"
                    />
                  </v-col>

                  <v-col cols="12" md="6" v-if="carteGriseBase64">
                    <v-btn text small class="mt-2" @click="openCarteGrise">
                      <v-icon left>mdi-file-document</v-icon>
                      {{ $t('Voir la carte grise') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            

            <v-col cols="12" class="pb-0">
              <v-row dense align="center" justify="space-between">
                <v-col cols="auto">
                  <div>
                    <h3 class="mb-1">{{ $t("Renseigner le kilometrage pendant le service ? ") }}</h3>
                    <p class="mb-0">{{ $t('Ceci permet le suivi du kilometrage de vehicule') }}</p>
                  </div>
                </v-col>
                <v-col cols="auto">
                  <v-switch
                    inset
                    color="success"
                    v-model="staff.is_kmh"
                    :label="staff.is_kmh ? 'Oui' : 'Non'"
                  />
                </v-col>
              </v-row>
            </v-col>

            <hr class="mt-1 mb-4" style="color: gray">

            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="staff.driver_last_name"
                  :rules="isDisable ? [] : rules.color"
                  :disabled="isDisable"
                  clearable
                  dense
                  outlined
                  :label="$t('Nom du conducteur')"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="staff.driver_first_name"
                  :rules="isDisable ? [] : rules.color"
                  :disabled="isDisable"
                  clearable
                  dense
                  outlined
                  :label="$t('Prenom du conducteur')"
                />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="staff.driver_phone_number"
                  :rules="isDisable ? [] : rules.driver_phone_number"
                  :disabled="isDisable"
                  @input="enforcePhoneFormat"
                  clearable
                  dense
                  outlined
                  :label="$t('N° de conducteur')"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="staff.secret_code"
                  :rules="isDisable ? [] : rules.secret_code"
                  :disabled="isDisable"
                  clearable
                  dense
                  outlined
                  :label="$t('Code secret')"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
      </template>

      <!-- ===== ACTIONS ===== -->
      <!-- <v-spacer></v-spacer> -->
      <template v-slot:actions>
        <!-- Desktop -->
        <v-card-actions
          v-if="$vuetify.breakpoint.mdAndUp"
          class="mr-4 justify-end"
        >
          <avs-saveButton @click="save" />
        </v-card-actions>

        <!-- Mobile : barre fixe -->
        <div
          v-else
          class="mobile-fixed-actions"
          v-show="!inDialog"
        >
          <v-btn
            block
            large
            color="primary"
            dark
            @click="save"
          >
            <v-icon left>mdi-content-save</v-icon>
            {{ $t('commons.save') }}
          </v-btn>
        </div>
      </template>
    </AvsSteppers>

    <avs-CloseDialog
      v-model="closeDialogIsOpen"
      @cancel="handleCancel"
      @confirm="handleConfirm"
    />
  </v-container>
</template>

<script>
import _ from "lodash"
const noop = () => undefined
import { CompanyVehiclesService, ProductDetailService, DepartmentService } from "@/services"
import { mkCompanyVehicle } from "@/utils/datamodels"

import { vehicleData, VEHICLE_ITEMS } from "@/utils/consts"
import { required, isNumber, max4, phone } from "@/utils/validator"

export default {
  name: "VehicleCreateUpdate",
  components: {
    AvsStep: () => import("@/components/generics/general/AvsStep.vue"),
    AvsSteppers: () => import("@/components/generics/general/AvsSteppers.vue"),
  },
  props: {
    inDialog: { type: Boolean, default: false },
    inDialogParams: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      staffRef: null,
      vehicleData,
      selectedBrand: null,
      selectedModel: null,
      carteGriseFile: null,
      carteGriseBase64: null,
      models: [],
      products: [],
      departments: [],
      staff: mkCompanyVehicle(),
      tab: this.$route.params.tab ? this.$route.params.tab : 1,
      nextLabel: this.$t("commons.next"),
      loading: false,
      step: -1,
      minReportDate: null,
      rules: {
        registration_number: [required],
        vehicle_type: [required],
        department: [],
        make: [required],
        model: [required],
        carte_grise: [required],
        reservoir_capacity: [isNumber],
        year: [isNumber, max4],
        driver_phone_number:[phone],
        driver_first_name:[required],
        driver_last_name:[required],
        company: [],
        color: [],
        products: [required],
        vin: [],
        other_model: [],
        other_make: [],
        secret_code: [required, max4, isNumber]
      },
      isFormValid: {
        informations: false,
        budgeet: false,
        causeAndResolution: false
      },
      validateRequest: { budgeet: 0 },
      isDisable: false,
      isClosed: false,
      closeDialogIsOpen: false,
      users: [],
    }
  },
  created() {
    this.fetchVehicle()
    this.fetchFieldTypes()
    this.fetchDepartmentTypes()
  },
  computed: {
    containerClasses() {
      return {
        'pa-2': this.$vuetify.breakpoint.smAndDown,
        'has-mobile-actions': this.$vuetify.breakpoint.smAndDown && !this.inDialog
      }
    },
    carteGriseRules() {
      if (this.isDisable) return []
      return this.carteGriseBase64 ? [] : this.rules.carte_grise
    },
    id() {
      return this.inDialog ? this.inDialogParams?.id : this.$route.params.id || null
    },
    staffExists() { return !!this.staff.id },
    company() { return this.$store.state.app.company },
    brands() { return [...Object.keys(this.vehicleData), "Autre"] },
    vehicleItems() { return VEHICLE_ITEMS }
  },
  watch: {
    tab(newValue, oldValue) {
      if (oldValue === 1) this.save()
    }
  },
  methods: {
    openCarteGrise() {
      const win = window.open()
      win.document.write(
        `<iframe src="${this.carteGriseBase64}" frameborder="0" style="width:100%;height:100%;"></iframe>`
      )
    },
    enforcePhoneFormat() {
      if (!this.staff.driver_phone_number) return
      if (!this.staff.driver_phone_number.startsWith("+225")) {
        this.staff.driver_phone_number = "+225" + this.staff.driver_phone_number.replace(/^(\+225)?/, "")
      }
    },
    save() {
      this.$refs["form-informations"].validate()
      this.$nextTick(() => {
        if (this.isFormValid.informations) {
          this.staffExists ? this.updateVehicle() : this.createVehicle()
        } else {
          this.tab = 1
          this.send(this.$t("messages.warning.all_required_info"), "warning")
        }
      })
    },
    handleCarteGriseUpload(file) {
      if (!file) {
        this.carteGriseBase64 = null
        this.staff.carte_grise = null
        return
      }
      const reader = new FileReader()
      reader.onload = () => {
        this.carteGriseBase64 = reader.result
        this.staff.carte_grise = this.carteGriseBase64
      }
      reader.readAsDataURL(file)
    },
    fetchFieldTypes() {
      ProductDetailService.getprincipalAll().then(response => {
        this.products = response.results
      })
    },
    fetchDepartmentTypes() {
      DepartmentService.getDepartment(this.company.pk).then(response => {
        this.departments = response
      })
    },
    updateModels() {
      if (this.selectedBrand === "Autre") {
        this.models = []
      } else {
        this.models = this.selectedBrand ? [...this.vehicleData[this.selectedBrand], "Autre"] : []
      }
      this.selectedModel = null
    },
    tabIncrement() {
      return this.tab < 4 ? this.tab++ : this.$router.push({ name: "CompanyVehicles" })
    },
    handleClose() { return this.$router.push({ name: "CompanyVehicles" }) },
    send(msg, color) { this.$store.commit("app/message", { msg, color }) },
    getVehicle(id) {
      if (!id) return
      CompanyVehiclesService.get(this, id).then(r => {
        this.staff = r
        this.selectedBrand = r.make
        this.updateModels()
        this.selectedModel = r.model
        this.staffRef = _.cloneDeep(this.staff)
        this.carteGriseBase64 = r.carte_grise
      })
    },
    createVehicle() {
      const tmp = _.cloneDeep(this.staff)
      tmp.model = this.selectedModel
      tmp.make  = this.selectedBrand
      this.loading = true
      CompanyVehiclesService.create(this, tmp)
        .then(response => {
          this.staff = response
          this.staffRef = _.cloneDeep(response)
          this.send(this.$t("messages.success.saved", { entity: this.$tc("categories.staff.name", 1) }), "success")
          this.$router.push({ name: "CompanyVehicles" })
        })
        .catch(err => {
          if (err?.response?.status === 403) {
            this.$store.commit("app/message", { msg: this.$t("messages.error.permission_denied"), color: "error" })
          } else {
            let message = ""
            for (const e in (err?.response?.data || {})) {
              message += `- ${e} : ${err.response.data[e]}\n`
            }
            this.$store.commit("app/message", { msg: message || this.$t("messages.error.unknown"), color: "error" })
          }
        })
        .finally(() => { this.loading = false })
    },
    updateVehicle() {
      const requests = []
      this.staff.model = this.selectedModel
      this.staff.make  = this.selectedBrand

      if (!_.isEqual(_.omit(this.staff), _.omit(this.staffRef))) {
        requests.push(CompanyVehiclesService.update(this, this.staff.id, _.omit(this.staff)))
      }
      if (!requests.length) {
        this.send(this.$t("messages.success.no_updated"), "info")
        return
      }
      this.loading = true
      Promise.all(requests)
        .then(() => {
          this.send(this.$t("messages.success.updated", { entity: this.$tc("categories.staff.name", 1) }), "success")
          this.$router.push({ name: "CompanyVehicles" })
        })
        .catch(err => {
          let message = ""
          for (const e in (err?.response?.data || {})) {
            message += `- ${e} : ${err.response.data[e]}\n`
          }
          this.send(message || this.$t("messages.error.unknown"), "error")
        })
        .finally(() => { this.loading = false })
    },
    fetchVehicle() { this.getVehicle(this.id) },
    handleError(msg) { this.$store.commit("app/message", { msg, color: "error" }) },
    handleSign() { this.isDisable = true },
    handleSuccess(isSaved, nextTab, postProcess = noop, message = null) {
      const msg_success = message || this.$t("messages.success.operation")
      const data = isSaved
        ? { msg: msg_success, color: "success" }
        : { msg: this.$t("messages.success.no_updated"), color: "info" }
      this.$store.commit("app/message", data)
      this.tab = nextTab
      postProcess()
    },
    handleConfirm() {
      CompanyVehiclesService.close(this, this.staff.id)
        .then(() => {
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.closed", { entity: this.$tc("categories.staff.name", 1) }),
            color: "success"
          })
          this.closeDialogIsOpen = false
          this.isClosed = true
        })
        .catch(err => {
          if (err?.response?.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
      this.closeDialogIsOpen = false
    },
    handleCancel() { this.closeDialogIsOpen = false }
  }
}
</script>

<style scoped>
/* barre fixe mobile */
.mobile-fixed-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 8px 12px;
  background: linear-gradient(180deg, rgba(255,255,255,0.1), rgba(255,255,255,1) 40%);
  z-index: 10;
  box-shadow: 0 -6px 16px rgba(16, 24, 40, 0.12);
}

/* espace bas pour éviter que le contenu passe sous la barre */
.has-mobile-actions {
  padding-bottom: 84px !important;
}

/* safe-area iPhone */
@supports (padding: max(0px)) {
  .mobile-fixed-actions {
    padding-bottom: max(8px, env(safe-area-inset-bottom));
  }
}
</style>
